var toObject = require('../internals/to-object');

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/has.js